// Ажилтны мэдэгдлийн хонх: тухайн хүнд хамаатай хүлээгдэж буй зүйлс (/notifications), 2 минут тутам шинэчилнэ.
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Badge, Popover } from "antd";
import { BiBell } from "react-icons/bi";
import { instance } from "utils/axios";

const DOT = { bad: "#d23b1f", warn: "#f2cd30", info: "#00bcd4" };

export default function NotificationBell() {
  const navigate = useNavigate();
  const [data, setData] = useState({ count: 0, items: [] });
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const load = () => instance({ method: "get", url: "/notifications", noMessage: true }).then((r) => setData(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 120000);
    return () => clearInterval(t);
  }, []);
  const content = (
    <div className="w-80 max-w-[80vw]">
      <div className="card-title mb-2">Мэдэгдэл</div>
      {!data.items.length ? <div className="text-sm text-gray-500 py-3">Хүлээгдэж буй зүйл алга</div> : data.items.map((it) => (
        <button key={it.key} type="button" onClick={() => { setOpen(false); navigate(it.link); }}
          className="w-full flex gap-2.5 items-start text-left bg-transparent border-0 border-t border-gray-100 first:border-t-0 py-2.5 cursor-pointer hover:bg-[#f3eeff] rounded-md px-1">
          <span className="mt-1.5 w-2.5 h-2.5 rounded-full shrink-0" style={{ background: DOT[it.kind] || DOT.info }} aria-hidden="true" />
          <span className="text-sm text-gray-800">{it.title}</span>
        </button>
      ))}
    </div>
  );
  return (
    <Popover content={content} trigger="click" placement="bottomRight" open={open} onOpenChange={setOpen}>
      <button type="button" aria-label={`Мэдэгдэл${data.count ? ` (${data.count})` : ""}`} className="ml-auto bg-transparent border-0 cursor-pointer p-1.5 rounded-full hover:bg-[#f3eeff]">
        <Badge count={data.count} size="small" color="#d23b1f">
          <BiBell size={22} className="bell-icon text-[#5c1090]" />
        </Badge>
      </button>
    </Popover>
  );
}
